import styled from 'styled-components';
import { themeGet } from 'styled-system';

const Path = styled.path`
  fill: ${({ fill }) => themeGet(`colors.${fill}`, fill)};
  stroke: ${({ stroke }) => themeGet(`colors.${stroke}`, stroke)};
`;

export default Path;
